import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16v-8h8","key":"svg-0"}]]

const IconChevronUpLeft = createReactComponent('outline', 'chevron-up-left', 'ChevronUpLeft', __iconNode);

export default IconChevronUpLeft;